/** @file cssPoint: where a world point is drawn, in CSS pixels from the viewport box's top-left. */
import type { Vec3 } from '@zilo/pose3d-math/vec3/vec3';
import { screenOf } from '@zilo/pose3d-render-core/camera/screenOf';
import { targetScreenOf } from './targetScreenOf';
import type { ViewportCtx } from './viewportCtx';

/**
 * `screenOf` gives target pixels; `targetScreenOf(layout).toCss` puts them on the box (the inverse of the pointer's
 * `targetPoint`). Before the first layout (tests), target pixels are returned as they are.
 */
export function cssPoint(ctx: ViewportCtx, p: Vec3): [number, number] {
  const view = ctx.scene?.camera.view();
  if (view === undefined) return [0, 0];
  const [x, y] = screenOf(p, view);
  const l = ctx.camera?.layout() ?? null;
  return l === null ? [x, y] : targetScreenOf(l).toCss(x, y);
}
